import { Usuario } from '@domain/usuario/usuario';
import { AuthDto } from '@infra/dto/auth.dto';
import { GrupoMapper } from '@infra/mappers/grupo.mapper';
import { MenuMapper } from '@infra/mappers/menu.mapper';
import { ProdutosEgtecMapper } from '@infra/mappers/produtos-egtec.mapper';
import { RedeMapper } from '@infra/mappers/rede.mapper';
import { DateTime } from 'luxon';

export class AuthMapper {
  static toDomain(authDto: AuthDto): Usuario {
    return {
      refreshToken: authDto.refreshToken,
      token: authDto.apiKey, // Substituindo apiKey por token
      expiracaoToken:
        DateTime.fromJSDate(new Date(authDto.expiracao))
          .setZone('America/Sao_Paulo')
          .toISO() ?? '',
      expiracaoRefreshToken:
        DateTime.fromJSDate(new Date(authDto.expiracaoRefreshToken))
          .setZone('America/Sao_Paulo')
          .toISO() ?? '',
      email: authDto.email,
      nome: authDto.nome,
      login: authDto.login,
      celular: authDto.celular,
      redes: authDto.redes.map(RedeMapper.toDomain),
      adminSistema: authDto.indAdministradorSistema,
      adminRedes: authDto.indAdministradorRedes,
      ativo: authDto.indAtivo,
      trocaSenha: authDto.indTrocaSenhaObrigatoria,
      menu: authDto.menu.map(MenuMapper.toDomain),
      grupo: authDto.grupo.map(GrupoMapper.toDomain),
      produtosEGTEC: authDto.produtosEGTEC.map(ProdutosEgtecMapper.toDomain)
    };
  }

  static toDTO(usuario: Usuario): AuthDto {
    return {
      refreshToken: usuario.refreshToken,
      apiKey: usuario.token,
      expiracao: usuario.expiracaoToken,
      expiracaoRefreshToken: usuario.expiracaoRefreshToken,
      erro: false,
      mensagem: null,
      statusCode: 200,
      email: usuario.email,
      nome: usuario.nome,
      login: usuario.login,
      celular: usuario.celular,
      redes: usuario.redes.map(RedeMapper.toDTO),
      indAdministradorSistema: usuario.adminSistema,
      indAdministradorRedes: usuario.adminRedes,
      indAtivo: usuario.ativo,
      indTrocaSenhaObrigatoria: usuario.trocaSenha,
      menu: usuario.menu.map(MenuMapper.toDTO),
      grupo: usuario.grupo.map(GrupoMapper.toDTO),
      produtosEGTEC: usuario.produtosEGTEC.map(ProdutosEgtecMapper.toDTO)
    };
  }
}
